/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';

import { IVehicleDiagnosticsResponse, IVehiclePlotWebsubsResponse } from '../../../core/models';

export enum EEcmDiagnosticsSocketActionTypes {
  UpdateVehicleDiagnosticAction = '[EcmDiagnosticsSocket] Update Vehicle Diagnostic',
  UpdateVehicleDiagnosticSuccessAction = '[EcmDiagnosticsSocket] Update Vehicle Diagnostic Success'
}

/**
 * Raw, per-vehicle real-time push coming straight from the websocket connector.
 * Carries the untouched socket payload; the mapping/merge is done in the effect.
 */
export class UpdateVehicleDiagnostic implements Action {
  public readonly type = EEcmDiagnosticsSocketActionTypes.UpdateVehicleDiagnosticAction;

  constructor(public payload: IVehiclePlotWebsubsResponse) {}
}

/**
 * Result of merging the socket values onto the current diagnostics. Consumed by the reducer.
 */
export class UpdateVehicleDiagnosticSuccess implements Action {
  public readonly type = EEcmDiagnosticsSocketActionTypes.UpdateVehicleDiagnosticSuccessAction;

  constructor(public payload: IVehicleDiagnosticsResponse) {}
}

export type EcmDiagnosticsSocketActions = UpdateVehicleDiagnostic | UpdateVehicleDiagnosticSuccess;
